import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconTranslationCreated = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M16 5L22 5"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 2L19 8"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.97046 7.65894L13.9824 7.65894"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.9913 7.75391C10.049 13.346 6.84242 15.9926 1.96681 16.156"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.71241 10.9332C7.81397 14.7129 9.90419 15.8082 13.6613 16.0848"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.2265 7.6576L7.22517 8.4076L8.72517 8.41026L8.7265 7.66026L7.2265 7.6576ZM8.73083 5.21129C8.73157 4.79708 8.39638 4.4607 7.98216 4.45996C7.56795 4.45923 7.23157 4.79442 7.23084 5.20863L8.73083 5.21129ZM8.7265 7.66026L8.73083 5.21129L7.23084 5.20863L7.2265 7.6576L8.7265 7.66026Z"
      fill="#00CB8B"
    />
    <path
      d="M10.8741 22.0039L12.449 18.7872M20.8043 22.0039L19.1965 18.7872M12.449 18.7872L15.7878 11.9676L19.1965 18.7872M12.449 18.7872H19.1965"
      stroke="#00CB8B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
